export default "__VITE_ASSET__ee299519__"